import { Quill } from 'react-quill-new';
import { css } from 'styled-components';

// Text coloured from a set of the theme's colours, saved as a class each
// (studio-color-blue…) so it follows light and dark mode wherever the text
// shows (see TEXT_COLOR_CSS). Any other colour is Quill's own inline colour,
// fixed as it was picked.
export const TEXT_COLOR_FORMAT = 'studio-color';
// Quill's own: a colour picked from the native picker
export const CUSTOM_TEXT_COLOR_FORMAT = 'color';

export const TEXT_COLORS: { id: string; label: string; color: string }[] = [
  { id: 'grey', label: 'Grey', color: 'var(--color-text-tertiary)' },
  { id: 'blue', label: 'Blue', color: 'var(--color-status-info)' },
  { id: 'purple', label: 'Purple', color: 'var(--color-brand-accent)' },
  { id: 'green', label: 'Green', color: 'var(--color-status-success)' },
  { id: 'amber', label: 'Amber', color: 'var(--color-status-amber)' },
  { id: 'orange', label: 'Orange', color: 'var(--color-status-orange)' },
  { id: 'red', label: 'Red', color: 'var(--color-status-danger-solid)' },
  { id: 'pink', label: 'Pink', color: 'var(--color-brand-primary)' },
];

const Parchment = Quill.import('parchment');

// Named as its classes are, so they're read back from saved HTML too
Quill.register(
  new Parchment.ClassAttributor(TEXT_COLOR_FORMAT, TEXT_COLOR_FORMAT, {
    scope: Parchment.Scope.INLINE,
    whitelist: TEXT_COLORS.map((c) => c.id),
  }),
  true,
);

// Wherever the text shows (Studio's editor, the classic Text gadget and its
// editor)
export const TEXT_COLOR_CSS = css`
  ${TEXT_COLORS.map(
    (c) => `.${TEXT_COLOR_FORMAT}-${c.id} { color: ${c.color}; }`,
  ).join('\n')}
`;
